import React from "react";
import "./style.css";

/**
 * @param {{
 * 	notes: string,
 * 	onNotesChange: (notes: string) => void
 * }} props
 */
export default function NotesSection({ notes, onNotesChange }) {
	return (
		<div className="invoice-section">
			<h3 className="invoice-section-title">Notes &amp; Payment Terms</h3>

			<div className="field">
				<label className="label" htmlFor="notes">
					Additional Notes
				</label>

				<textarea
					id="notes"
					className="notes-textarea"
					placeholder="Payment is due within 30 days. Please include the invoice number with your payment. Thank you for your business!"
					value={notes || ""}
					onChange={(e) => onNotesChange(e.target.value)}
				/>
			</div>
		</div>
	);
}
